import { render, staticRenderFns } from "./GebruikersBase.vue?vue&type=template&id=cec17b3c&scoped=true"
import script from "./GebruikersBase.vue?vue&type=script&lang=js"
export * from "./GebruikersBase.vue?vue&type=script&lang=js"
import style0 from "./GebruikersBase.vue?vue&type=style&index=0&id=cec17b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec17b3c",
  null
  
)

export default component.exports